import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _Addguideproduct, _CreateProductRow, _CreateTransportGuideItems, _GuideItemList, _InventoryCatalogByMarke, _InvoiceTransportGuide, _MarketPlaceCategory, _MarketPlaceGuide, _MarketPlacePrice, _TransportGuideInfo, _TransportGuideItem, _TransportGuideProduct } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { GoodsStateEditor } from "../GoodsState/GoodsStateEditor";
import { GoodsSupportEditor } from "../GoodsSupport/GoodsSupportEditor";
import { GoodsTypeEditor } from "../GoodsType/GoodsTypeEditor";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { InventoryCatalogByMarketEditor } from "./InventoryCatalogByMarketEditor";
import { TransportGuideItemNew } from "./TransportGuideItemNew";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { TransportGuidePaymentForm } from "./TransportGuidePaymentForm/TransportGuidePaymentForm";
import useModal, { MODAL_LG } from "../../../theme/Component/hooks/useModal";

interface Props {
    idOffice?: any,
    view?: boolean;
    idTransportGuide: number;
    transportGuideDate: any;
}

export const PiezesServices = ({ idTransportGuide, transportGuideDate, view, idOffice }: Props) => {

    const acordeon = useDataBean(_TransportGuideItem);
    const createtransp = useDataBean(_CreateTransportGuideItems);
    const acordeonproduct = useDataBean(_TransportGuideProduct);
    const guide = useDataBean(_GuideItemList);
    const [DocInfo, setDocInfo] = useState<any>(null)
    const [itemsguide, setitemsguide] = useState<any>([]);
    const addguideproduct = useDataBean(_Addguideproduct);
    const marketproduct = useDataBean(_MarketPlaceGuide);
    const createProductRow = useDataBean(_CreateProductRow);
    const [IDMarketPlace, setIDMarketPlace] = useState(null);
    const single = Singleton.getInstance();
    const paginador = usePaginator();
    const transinvoice = useDataBean(_InvoiceTransportGuide);
    const paginadortwo = usePaginator();

    const [infoLiquidate, setInfoLiquidate] = useState<any>({});
    const infoGuide = useDataBean(_TransportGuideInfo);

    const modalPay = useModal("Metodos de Pago", MODAL_LG)

    const [lista, setLista] = useState<any>([]);
    const [listatwo, setListatwo] = useState<any>([]);
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalviewdoc, setModalviewdoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalgenerate, setModalgenerate] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalgeneratepieze, setModalgeneratepieze] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalservice, setModalservice] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalAddservice, setModalAddservice] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        const alto = Number(acordeon.bean.HightLength) || 0;
        const ancho = Number(acordeon.bean.WidthLength) || 0;
        const largo = Number(acordeon.bean.LongLength) || 0;

        const volumen = alto * ancho * largo;

        acordeon.setBean({
            ...acordeon.bean,
            Volume: volumen
        });

    }, [
        acordeon.bean.HightLength,
        acordeon.bean.WidthLength,
        acordeon.bean.LongLength
    ]);

    useEffect(() => {
        if (modalAddservice.view) {
            getListaMarketProduct();
        }
    }, [modalAddservice.view]);

    useEffect(() => {
        getLista();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idTransportGuide, transportGuideDate, paginador.page])

    const getTransportGuideItemValues = () => {
        infoGuide.instance.getTransportGuideItemValues(idTransportGuide, transportGuideDate).then(
            (resp) => {
                setInfoLiquidate(resp)

                // toast.success('Realizado');
            }
        ).catch(err => {
            toast.error(err);
        });
    };

    const getLista = () => {
        acordeon.instance.getTransportGuideItemCatalog(idTransportGuide, transportGuideDate, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15)
                setLista(resp.List)
                console.log(resp.List)
                getTransportGuideItemValues()
                // const x = resp.List.map(item => ({
                //     ...item,
                //     LiquidatedLabel:
                //         item.Liquidated === true
                //             ? "Liquidado"
                //             : item.Liquidated === false
                //                 ? "No liquidado"
                //                 : "-",

                //     LiquidatedColor:
                //         item.Liquidated === true
                //             ? "green"
                //             : item.Liquidated === false
                //                 ? "red"
                //                 : "gray"
                // }));

                // setLista(x);
            }
        );
    }

    const deleteTransportGuideItem = () => {

        acordeon.instance.deleteTransportGuideItem(transportGuideDate, acordeon.bean.IDTransportGuideItem).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);
                    getLista();
                    setModalC({ ...modalC, "view": false });

                }
            }
        )
    }

    useEffect(() => {
        getListatwo();
    }, [idTransportGuide, transportGuideDate, paginadortwo.page])

    const getListatwo = () => {

        acordeonproduct.instance.getTransportGuideProductCatalog(idTransportGuide, transportGuideDate, paginadortwo.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginadortwo.setPages(resp.NumberOfPages);
                    paginadortwo.setRecords(resp.NumberOfPages * (15));
                    paginadortwo.setRegiPerPage(15)
                    setListatwo(resp.List)
                }
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDTransportGuideItem', visible: true },
        { title: 'Código Barras', property: 'TicketCode', visible: true },
        { title: 'Estado de Carga', property: 'GoodsStateName', visible: true },
        { title: 'Soporte de Carga', property: 'GoodsSupportName', visible: true },
        { title: 'Tipo de Carga', property: 'GoodsTypeName', visible: true },
        { title: 'Peso (Kg)', property: 'WeightKg', visible: true },
        { title: 'P/Real (Kg)', property: 'WeightKgReal', visible: true },
        { title: 'Largo (cm)', property: 'LongLength', visible: true },
        { title: 'Ancho (cm)', property: 'WidthLength', visible: true },
        { title: 'Alto (cm)', property: 'HightLength', visible: true },
        { title: 'Volumen', property: 'Volume', visible: true },
        { title: 'Descripción Pieza', property: 'Description', visible: true },
        { title: 'Total Liquidación', property: 'TotalAmount', visible: true, mask: MASK_MONEY },
        { title: 'Descuento', property: 'DiscountAmount', visible: true, mask: MASK_MONEY },
        { title: 'Valor Seguro', property: 'PolicyValue', visible: true, mask: MASK_MONEY },
        { title: 'Otros Valores', property: 'OthersValue', visible: true, mask: MASK_MONEY },
        { title: 'Errores de Liquidación', property: 'ErrorMessage', visible: true },
        { title: 'Liquidado', property: 'Liquidated', visible: true },
        { title: 'Tipo de Liquidación', property: 'LiquidateTypeName', visible: true },
        { title: 'Tipo Facturación', property: 'InvoiceFreightTypeName', visible: true },
        { title: 'Tipo de Carga', property: 'FreightTypeName', visible: true },
        { title: 'Kg Liquidados', property: 'LiquidatedKg', visible: true },
        { title: 'Valor Carga Liquidado', property: 'LiquidatedValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Básico', property: 'LiquidatedBasic', visible: true, mask: MASK_MONEY },
        { title: 'Tarifa (Kg)', property: 'RateValue', visible: true },
        { title: 'ID Producto', property: 'IDProduct', visible: true },
        { title: 'ID Producto Poliza', property: 'IDProductPolicy', visible: true },

    ]

    const headtwo = [
        { title: 'Producto', property: 'ProductDescription', visible: true },
        { title: 'Código de Producto', property: 'ProductCode', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Vr Unitario', property: 'PriceValue', visible: true },
        { title: 'Vr Total', property: 'TotalItemAmount', visible: true },
    ]
    const generate = () => {
        setModalgenerate({ ...modalgenerate, "view": true });
    }
    const createservice = () => {
        acordeonproduct.setBean({
            IDTransportGuide: idTransportGuide,
            TransportGuideDate: transportGuideDate
        });
        setModalAddservice({ ...modalAddservice, "view": true });
    }

    const createpiece = () => {
        acordeon.setBean({
            IDTransportGuide: idTransportGuide,
            TransportGuideDate: transportGuideDate,
        });
        setModal({ ...modal, "view": true });
    }


    const editaItem = () => {
        acordeon.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const editaItemtwo = () => {
        acordeonproduct.update().then(
            (resp: any) => {
                getLista();
                setModalservice({ ...modalservice, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const addTransportGuideProduct = () => {
        addguideproduct.instance.addTransportGuideProduct(idTransportGuide, transportGuideDate, null).then(
            (resp: any) => {
                getLista();
                setModalservice({ ...modalservice, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const createTransportGuideItems = () => {

        createtransp.instance.createTransportGuideItems(idTransportGuide, transportGuideDate, createtransp.bean.PiecesNumber).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModalgenerate({ ...modalgenerate, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {

        setModalgeneratepieze({ ...modalgeneratepieze, "view": true });

    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const listaBotonestwo = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalservice({ ...modalservice, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const getListaMarketProduct = () => {

        marketproduct.instance.getMarketPlaceForTransportGuide(idOffice).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp.IDMarketPlace)
                    setIDMarketPlace(resp.IDMarketPlace)
                }
            }
        )

    }
    const invoiceTransportGuide = () => {
        transinvoice.instance.invoiceTransportGuide(idTransportGuide, transportGuideDate, _single.getAccountID()).then(
            (resp: any) => {
                if (resp.DocumentURL) {
                    console.log(resp)
                    setDocInfo(resp.DocumentURL);
                    setModalviewdoc({ ...modalviewdoc, "view": true })
                } else {
                    toast.error('Sin Documento');
                }
            }
        ).catch(err => {
            toast.error(err);
        })
    }
    const createProductRowWithPriceListItem = () => {
        createProductRow.instance.createProductRowWithPriceListItem(createProductRow.bean.IDMarketPlaceProduct, createProductRow.bean.IDPriceListItem, createProductRow.bean.Quantity).then(
            (resp: any) => {
                console.log(resp)
                toast.success('Realizado');

            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const addTransportGuideItemList = () => {
        guide.instance.addTransportGuideItemList(idTransportGuide, transportGuideDate, itemsguide, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                getLista();
                setModalgeneratepieze({ ...modalgeneratepieze, "view": false });
                toast.success('Realizado')
            }
        ).catch(err => {
            toast.error(err)
        })
    }
    return (
        <div className="row">

            <div className="col-md-12">
                {view === true ? (
                    <div className="row">
                        <div className="col-12">
                            <table className="table table-bordered table-sm">
                                <thead className="table-light">
                                    <tr>
                                        {/* <th>Peso Real (Kg)</th> */}
                                        <th>Peso (Kg)</th>
                                        <th>Flete</th>
                                        <th>Seguro</th>
                                        <th>Otros</th>
                                        <th>Descuento</th>
                                        <th>Total</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Object.keys(infoLiquidate).length > 0 ? (
                                        <tr>
                                            {/* <td>{item.WeightKgReal ?? "-"}</td> */}
                                            <td>{infoLiquidate.WeightKg ?? "-"}</td>
                                            <td>{infoLiquidate.TotalAmount?.toLocaleString() ?? "-"}</td>
                                            <td>{infoLiquidate.PolicyValue?.toLocaleString() ?? "-"}</td>
                                            <td>{infoLiquidate.OthersValue?.toLocaleString() ?? "-"}</td>
                                            <td>{infoLiquidate.DiscountAmount?.toLocaleString() ?? "-"}</td>
                                            <td>{infoLiquidate.TotalPayment?.toLocaleString() ?? "-"}</td>
                                        </tr>
                                    ) : (
                                        <tr>
                                            <td colSpan={6} className="text-center">
                                                Sin información
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="col-md-12">
                            <label>Detalle de Piezas</label>
                        </div>
                        {/* <div className="col-md-4">
                            <BasicButton icon="ri-archive-drawer-fill" clase="btn btn-outline-primary btn-border" eventClick={generate}>
                                Generar Piezas de Carga
                            </BasicButton>
                        </div> */}
                        <div className="col-md-3">
                            <BasicButton icon="ri-layout-grid-fill" clase="btn btn-primary" eventClick={invoiceTransportGuide}>
                                Facturar Guia de Transporte
                            </BasicButton>
                            <Modal modal={modalviewdoc} updateModal={setModalviewdoc}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <DocumentViewer list={DocInfo} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-3">
                            <BasicButton icon="ri-money-dollar-circle-line" clase="btn btn-primary" eventClick={() => { modalPay.open() }}>
                                Metodos de Pago
                            </BasicButton>
                            <Modal modal={modalPay.modal} updateModal={modalPay.setModal}>
                                <TransportGuidePaymentForm TransportGuide={{ IDTransportGuide: idTransportGuide, TransportGuideDate: transportGuideDate }} />
                            </Modal>
                        </div>
                        {/* <div className="col-md-3">
                            <BasicButton icon="ri-file-search-line" clase="btn btn-primary" eventClick={getLista}>
                                Consultar
                            </BasicButton>
                        </div> */}
                        <div className="col-md-12">
                            <BasicTable body={lista} head={head} listButtons={listaBotones()} iconButtons={iconButtonsItem} rowSet={acordeon.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                        </div>



                        <div className="col-md-12">
                            <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <GoodsStateEditor render={acordeon.bean.GoodsStateName} idSelector={acordeon.bean.IDGoodsState} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "IDGoodsState": e.IDGoodsState, "GoodsStateName": e.Name }) }} returnType="Object" />

                                    </div>
                                    <div className="col-md-6">

                                        <GoodsSupportEditor render={acordeon.bean.GoodsSupportName} idSelector={acordeon.bean.IDGoodsSupport} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "IDGoodsSupport": e.IDGoodsSupport, "GoodsSupportName": e.Name }) }} returnType="Object" />

                                    </div>
                                    <div className="col-md-6">
                                        <GoodsTypeEditor render={acordeon.bean.GoodsTypeName} idSelector={acordeon.bean.IDGoodsType} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "IDGoodsType": e.IDGoodsType, "GoodsTypeName": e.Name }) }} returnType="Object" />

                                    </div>
                                    <div className="col-md-6">
                                        <label>Peso (Kg)</label>
                                        <input type="text" className="form-control" name='WeightKg' value={acordeon.bean.WeightKg} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "WeightKg": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>P/Real (Kg)</label>
                                        <input type="text" className="form-control" name='WeightKgReal' value={acordeon.bean.WeightKgReal} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "WeightKgReal": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Largo (cm)</label>
                                        <input type="text" className="form-control" name='LongLength' value={acordeon.bean.LongLength} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "LongLength": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Ancho (cm)</label>
                                        <input type="text" className="form-control" name='WidthLength' value={acordeon.bean.WidthLength} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "WidthLength": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Alto (cm)</label>
                                        <input type="text" className="form-control" name='HightLength' value={acordeon.bean.HightLength} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "HightLength": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Volumen</label>
                                        <input type="text" className="form-control" name='Volume' value={acordeon.bean.Volume} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "Volume": e.target.value }) }} readOnly />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Descripción Pieza</label>
                                        <textarea className="form-control" name='Description' value={acordeon.bean.Description} onChange={(e) => { acordeon.setBean({ ...acordeon.bean, "Description": e.target.value }) }} />
                                    </div>
                                </div>
                            </Modal>

                            <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteTransportGuideItem}>
                                <strong>Eliminar item {acordeon.bean.Name}</strong>
                            </ModalConfirm>
                        </div>
                        {/* <div className="col-md-12">
                            <Modal modal={modalgenerate} updateModal={setModalgenerate} eventModal={createTransportGuideItems}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Número de Piezas</label>
                                        <input type="text" className="form-control" name='PiecesNumber' value={createtransp.bean.PiecesNumber} onChange={(e) => { createtransp.setBean({ ...createtransp.bean, "PiecesNumber": parseInt(e.target.value) }) }} />
                                    </div>
                                </div>
                            </Modal>
                        </div> */}
                        <div className="col-md-12">
                            <Modal modal={modalgeneratepieze} updateModal={setModalgeneratepieze} eventModal={addTransportGuideItemList}>
                                <div className="row">
                                    <TransportGuideItemNew value={itemsguide} onChange={(data) => setitemsguide(data)} />
                                </div>
                            </Modal>
                        </div>
                    </div>
                ) : (
                    <div className="row">

                        <label>Servicios Adicionales</label>
                        <div className="col-md-4">
                            <BasicButton icon="ri-contacts-book-upload-fill" clase="btn btn-outline-primary btn-border" eventClick={createservice}>
                                Crear
                            </BasicButton>
                        </div>
                        <div className="col-md-4">
                            <BasicButton icon="ri-file-search-line" clase="btn btn-primary" eventClick={getListatwo}>
                                Consultar
                            </BasicButton>
                        </div>
                        <div className="col-md-12">
                            <BasicTable body={listatwo} head={headtwo} listButtons={listaBotonestwo()} rowSet={acordeonproduct.setBean} pageTop={paginadortwo.page} next={paginadortwo.next} back={paginadortwo.back} records={paginadortwo} customRows={15}></BasicTable>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={modalservice} updateModal={setModalservice} eventModal={editaItemtwo}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label>Cantidad</label>
                                        <input type="text" className="form-control" name='Quantity' value={acordeonproduct.bean.Quantity} onChange={(e) => { acordeonproduct.setBean({ ...acordeonproduct.bean, "Quantity": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-6">
                                        <label>Vr Total</label>
                                        <input type="text" className="form-control" name='TotalItemAmount' value={acordeonproduct.bean.TotalItemAmount} onChange={(e) => { acordeonproduct.setBean({ ...acordeonproduct.bean, "TotalItemAmount": e.target.value }) }} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">

                        </div>
                        <div className="col-md-12">
                            <Modal modal={modalAddservice} updateModal={setModalAddservice} >
                                <div className="row">
                                    <div className="col-md-6">
                                        <strong>ID Oficina:</strong>{idOffice}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>ID Market Place:</strong>  {IDMarketPlace}
                                    </div>
                                    <div className="col-md-12">
                                        <InventoryCatalogByMarketEditor idMarketPlace={IDMarketPlace} render={createProductRow.bean.Description} idSelector={createProductRow.bean.IDMarketPlaceProduct} onChange={(e) => { createProductRow.setBean({ ...createProductRow.bean, "IDMarketPlaceProduct": e.IDMarketPlaceProduct, "Description": e.IDMarketPlaceProduct, "IDPriceListItem": e.IDPriceListItem }) }} returnType="Object" />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Cantidad</label>
                                        <input type="text" className="form-control" name='Quantity' value={createProductRow.bean.Quantity} onChange={(e) => { createProductRow.setBean({ ...createProductRow.bean, "Quantity": e.target.value }) }} />
                                    </div>
                                    <div className="col-md-12 mt-4">
                                        <BasicButton icon="ri-send-plane-fill" clase="btn btn-primary" eventClick={createProductRowWithPriceListItem} disable={
                                            !createProductRow.bean?.IDMarketPlaceProduct ||
                                            !createProductRow.bean?.Quantity ||
                                            Number(createProductRow.bean?.Quantity) <= 0
                                        }>
                                            Agregar Producto Lista de Precios
                                        </BasicButton>
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}